<app-toggle-button
        (valueChanged)="darkModeService.toggleState()"
        [ngModel]="darkModeService.state$ | async"
        [onStateIcon]="IconsEnum.sun"
        [offStateIcon]="IconsEnum.moon">
</app-toggle-button>